"use strict";
/*---------------------------------------------------------------------------------------------
*  Licensed to the .NET Foundation under one or more agreements.
*  The .NET Foundation licenses this file to you under the MIT license.
*--------------------------------------------------------------------------------------------*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockInstallTracker = exports.MockExtensionConfiguration = exports.MockLoggingObserver = exports.MockInstallationValidator = exports.MockTelemetryReporter = exports.FailingInstallScriptWorker = exports.MockDistroProvider = exports.MockFileUtilities = exports.MockCommandExecutor = exports.MockAcquisitionInvoker = exports.MockApostropheScriptAcquisitionWorker = exports.MockInstallScriptWorker = exports.MockVersionResolver = exports.MockVSCodeEnvironment = exports.MockVSCodeExtensionContext = exports.MockIndexWebRequestWorker = exports.MockWebRequestWorker = exports.MockTrackingWebRequestWorker = exports.FailingWebRequestWorker = exports.FileWebRequestWorker = exports.versionPairs = exports.ErrorAcquisitionInvoker = exports.RejectingAcquisitionInvoker = exports.MockDotnetCoreAcquisitionWorker = exports.NoInstallAcquisitionInvoker = exports.MockEventStream = exports.MockExtensionContext = void 0;
const fs = require("fs");
const path = require("path");
const AcquisitionInvoker_1 = require("../../Acquisition/AcquisitionInvoker");
const DotnetCoreAcquisitionWorker_1 = require("../../Acquisition/DotnetCoreAcquisitionWorker");
const DotnetInstall_1 = require("../../Acquisition/DotnetInstall");
const GenericDistroSDKProvider_1 = require("../../Acquisition/GenericDistroSDKProvider");
const IAcquisitionInvoker_1 = require("../../Acquisition/IAcquisitionInvoker");
const IDistroDotnetSDKProvider_1 = require("../../Acquisition/IDistroDotnetSDKProvider");
const IInstallationValidator_1 = require("../../Acquisition/IInstallationValidator");
const InstallScriptAcquisitionWorker_1 = require("../../Acquisition/InstallScriptAcquisitionWorker");
const InstallTrackerSingleton_1 = require("../../Acquisition/InstallTrackerSingleton");
const VersionResolver_1 = require("../../Acquisition/VersionResolver");
const EventStreamEvents_1 = require("../../EventStream/EventStreamEvents");
const IVSCodeExtensionContext_1 = require("../../IVSCodeExtensionContext");
const CommandExecutor_1 = require("../../Utils/CommandExecutor");
const FileUtilities_1 = require("../../Utils/FileUtilities");
const ICommandExecutor_1 = require("../../Utils/ICommandExecutor");
const IFileUtilities_1 = require("../../Utils/IFileUtilities");
const IVSCodeEnvironment_1 = require("../../Utils/IVSCodeEnvironment");
const TypescriptUtilities_1 = require("../../Utils/TypescriptUtilities");
const WebRequestWorkerSingleton_1 = require("../../Utils/WebRequestWorkerSingleton");
const TestUtility_1 = require("../unit/TestUtility");
const testDefaultTimeoutTimeMs = 60000;
class MockExtensionContext {
    constructor() {
        this.values = {};
    }
    get(key, defaultValue) {
        let value = this.values[key];
        if (typeof value === 'undefined') {
            value = defaultValue;
        }
        return value;
    }
    update(key, value) {
        return this.values[key] = value;
    }
    clear() {
        this.values = {};
    }
    keys() {
        return Object.keys(this.values);
    }
}
exports.MockExtensionContext = MockExtensionContext;
class MockEventStream {
    constructor() {
        this.events = [];
    }
    post(event) {
        this.events = this.events.concat(event);
    }
}
exports.MockEventStream = MockEventStream;
class NoInstallAcquisitionInvoker extends IAcquisitionInvoker_1.IAcquisitionInvoker {
    constructor(eventStream, worker, workerContext, path) {
        super(eventStream);
        this.workerContext = workerContext;
        this.path = path;
        worker.enableNoInstallInvoker();
    }
    installDotnet(install) {
        var _a, _b, _c;
        const testInstallContext = {
            version: install.version,
            installMode: install.installMode,
            architecture: (_a = install.architecture) !== null && _a !== void 0 ? _a : 'null',
            dotnetPath: (_b = path.join(this.path, (0, TypescriptUtilities_1.getDotnetExecutable)())) !== null && _b !== void 0 ? _b : path.join(this.workerContext.installDirectoryProvider.getInstallDir(install.installId), (0, TypescriptUtilities_1.getDotnetExecutable)()),
            installDir: (_c = this.path) !== null && _c !== void 0 ? _c : this.workerContext.installDirectoryProvider.getInstallDir(install.installId),
            installType: install.isGlobal ? 'global' : 'local',
            timeoutSeconds: testDefaultTimeoutTimeMs,
        };
        return new Promise((resolve, reject) => {
            var _a;
            this.eventStream.post(new EventStreamEvents_1.TestAcquireCalled(testInstallContext));
            const install = (0, DotnetInstall_1.GetDotnetInstallInfo)(testInstallContext.version, testInstallContext.installMode, 'local', (_a = testInstallContext.architecture) !== null && _a !== void 0 ? _a : 'null');
            this.eventStream.post(new EventStreamEvents_1.DotnetAcquisitionCompleted(install, testInstallContext.dotnetPath, testInstallContext.version));
            resolve();
        });
    }
}
exports.NoInstallAcquisitionInvoker = NoInstallAcquisitionInvoker;
class MockDotnetCoreAcquisitionWorker extends DotnetCoreAcquisitionWorker_1.DotnetCoreAcquisitionWorker {
    constructor(utilityContext, extensionContext) {
        super(utilityContext, extensionContext);
    }
    enableNoInstallInvoker() {
        this.usingNoInstallInvoker = true;
    }
}
exports.MockDotnetCoreAcquisitionWorker = MockDotnetCoreAcquisitionWorker;
class RejectingAcquisitionInvoker extends IAcquisitionInvoker_1.IAcquisitionInvoker {
    installDotnet(install) {
        return new Promise((resolve, reject) => {
            reject('Rejecting message');
        });
    }
}
exports.RejectingAcquisitionInvoker = RejectingAcquisitionInvoker;
class ErrorAcquisitionInvoker extends IAcquisitionInvoker_1.IAcquisitionInvoker {
    installDotnet(install) {
        throw new EventStreamEvents_1.EventBasedError('MockErrorAcquisitionInvokerFailure', 'Command Failed');
    }
}
exports.ErrorAcquisitionInvoker = ErrorAcquisitionInvoker;
// Major.Minor-> Major.Minor.Patch from mock releases.json
exports.versionPairs = [['1.0', '1.0.16'], ['1.1', '1.1.13'], ['2.0', '2.0.9'], ['2.1', '2.1.14'], ['2.2', '2.2.8']];
class FileWebRequestWorker extends WebRequestWorkerSingleton_1.WebRequestWorkerSingleton {
    constructor(mockFilePath) {
        super();
        this.mockFilePath = mockFilePath;
        const _ = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance(); // cause super to exist
    }
    makeWebRequest(uri, ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = JSON.parse(fs.readFileSync(this.mockFilePath, 'utf8'));
            return result;
        });
    }
}
exports.FileWebRequestWorker = FileWebRequestWorker;
class FailingWebRequestWorker extends WebRequestWorkerSingleton_1.WebRequestWorkerSingleton {
    constructor() {
        // Use Empty strings as uri to cause failure. Uri is required to match the interface even though it's unused.
        super();
        const _ = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance(); // cause super to exist
    }
    getCachedData(uri, ctx) {
        return __awaiter(this, void 0, void 0, function* () {
            throw new Error('Fail!');
        });
    }
    makeWebRequest(uri, ctx) {
        const _super = Object.create(null, {
            makeWebRequest: { get: () => super.makeWebRequest }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.makeWebRequest.call(this, '', ctx, true, 0);
        });
    }
    downloadFile(url, dest, ctx) {
        const _super = Object.create(null, {
            downloadFile: { get: () => super.downloadFile }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.downloadFile.call(this, '', dest, ctx);
        });
    }
}
exports.FailingWebRequestWorker = FailingWebRequestWorker;
class MockTrackingWebRequestWorker extends WebRequestWorkerSingleton_1.WebRequestWorkerSingleton {
    constructor(succeed = true) {
        super();
        this.succeed = succeed;
        this.requestCount = 0;
        this.response = 'Mock Web Request Result';
        const _ = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance(); // cause super to exist
    }
    getRequestCount() {
        return this.requestCount;
    }
    incrementRequestCount() {
        this.requestCount++;
    }
    makeWebRequest(url_1, ctx_1) {
        const _super = Object.create(null, {
            makeWebRequest: { get: () => super.makeWebRequest }
        });
        return __awaiter(this, arguments, void 0, function* (url, ctx, shouldThrow = false, retries = 2) {
            if (!(yield this.isUrlCached(url, ctx))) {
                this.incrementRequestCount();
            }
            return _super.makeWebRequest.call(this, url, ctx, shouldThrow, retries);
        });
    }
}
exports.MockTrackingWebRequestWorker = MockTrackingWebRequestWorker;
class MockWebRequestWorker extends MockTrackingWebRequestWorker {
    constructor() {
        super();
        this.errorMessage = 'Web Request Failed';
        this.response = 'Mock Web Request Result';
        const _ = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance(); // cause super to exist
    }
    makeWebRequest() {
        return __awaiter(this, void 0, void 0, function* () {
            this.incrementRequestCount();
            if (this.succeed) {
                try // axios will return a json object instead of a string if the object is json. mimic this.
                 {
                    JSON.parse(this.response);
                }
                catch (e) {
                    return this.response;
                }
            }
            else {
                throw new Error(this.errorMessage);
            }
        });
    }
}
exports.MockWebRequestWorker = MockWebRequestWorker;
class MockIndexWebRequestWorker extends WebRequestWorkerSingleton_1.WebRequestWorkerSingleton {
    constructor(succeed = true) {
        super();
        this.succeed = succeed;
        this.knownUrls = ['Mock Web Request Result'];
        this.matchingUrlResponses = [
            ``
        ];
        const _ = WebRequestWorkerSingleton_1.WebRequestWorkerSingleton.getInstance(); // cause super to exist
    }
    getCachedData(url_1, ctx_1) {
        return __awaiter(this, arguments, void 0, function* (url, ctx, retriesCount = 2) {
            const urlResponseIndex = this.knownUrls.indexOf(url);
            if (urlResponseIndex === -1) {
                throw Error(`The requested URL ${url} was not expected as the mock object did not have a set response for it.`);
            }
            return JSON.parse(this.matchingUrlResponses[urlResponseIndex]);
        });
    }
}
exports.MockIndexWebRequestWorker = MockIndexWebRequestWorker;
class MockVSCodeExtensionContext extends IVSCodeExtensionContext_1.IVSCodeExtensionContext {
    registerOnExtensionChange(f, ...args) {
        f(...args);
    }
    getExtensions() {
        return [{ extensionId: 'test' }];
    }
    executeCommand(command, ...args) {
        return Promise.resolve({});
    }
    appendToEnvironmentVariable(variable, pathAdditionWithDelimiter) {
        // Do nothing.
    }
    setVSCodeEnvironmentVariable(variable, value) {
        // Do nothing.
    }
}
exports.MockVSCodeExtensionContext = MockVSCodeExtensionContext;
class MockVSCodeEnvironment extends IVSCodeEnvironment_1.IVSCodeEnvironment {
    isTelemetryEnabled() {
        return true;
    }
}
exports.MockVSCodeEnvironment = MockVSCodeEnvironment;
class MockVersionResolver extends VersionResolver_1.VersionResolver {
    constructor(ctx) {
        super(ctx);
        this.filePath = path.join(__dirname, '../../..', 'src', 'test', 'mocks', 'mock-releases.json');
        this.webWorker = new FileWebRequestWorker(this.filePath);
    }
}
exports.MockVersionResolver = MockVersionResolver;
class MockInstallScriptWorker extends InstallScriptAcquisitionWorker_1.InstallScriptAcquisitionWorker {
    constructor(ctx, failing, fallback = false) {
        super(ctx);
        this.fallback = fallback;
        this.webWorker = failing ?
            new FailingWebRequestWorker() :
            new MockWebRequestWorker();
    }
    getFallbackScriptPath() {
        if (this.fallback) {
            return path.join(__dirname, '..');
        }
        else {
            return super.getFallbackScriptPath();
        }
    }
}
exports.MockInstallScriptWorker = MockInstallScriptWorker;
class MockApostropheScriptAcquisitionWorker extends MockInstallScriptWorker {
    constructor(ctx, installFolder) {
        super(ctx, false);
        const scriptFileEnding = 'win32';
        const scriptFileName = 'dotnet-install';
        this.scriptFilePath = path.join(installFolder, 'install scripts', `${scriptFileName}.${scriptFileEnding}`);
    }
}
exports.MockApostropheScriptAcquisitionWorker = MockApostropheScriptAcquisitionWorker;
class MockAcquisitionInvoker extends AcquisitionInvoker_1.AcquisitionInvoker {
    constructor(ctx, installFolder) {
        super(ctx, (0, TestUtility_1.getMockUtilityContext)());
        this.scriptWorker = new MockApostropheScriptAcquisitionWorker(ctx, installFolder);
    }
}
exports.MockAcquisitionInvoker = MockAcquisitionInvoker;
/**
 * @remarks does NOT run the commands (if they have sudo), but records them to verify the correct command should've been run.
 */
class MockCommandExecutor extends ICommandExecutor_1.ICommandExecutor {
    constructor(acquisitionContext, utilContext) {
        super(acquisitionContext, utilContext);
        this.fakeReturnValue = { status: '', stderr: '', stdout: '' };
        this.attemptedCommand = '';
        // If you expect several commands to be run and want to specify unique outputs for each, describe them in the same order using the below two arrays.
        // We will check for an includes match and not an exact match!
        this.otherCommandPatternsToMock = [];
        this.otherCommandsReturnValues = [];
        this.acquisitionContext = acquisitionContext;
        this.trueExecutor = new CommandExecutor_1.CommandExecutor(acquisitionContext, utilContext);
    }
    execute(command_1) {
        return __awaiter(this, arguments, void 0, function* (command, options = null, terminalFailure) {
            this.attemptedCommand = CommandExecutor_1.CommandExecutor.prettifyCommandExecutorCommand(command);
            this.acquisitionContext.eventStream.post(new EventStreamEvents_1.CommandExecutionEvent(`Executing command: ${this.attemptedCommand}`));
            for (let i = 0; i < this.otherCommandPatternsToMock.length; ++i) {
                const commandPatternToLookFor = this.otherCommandPatternsToMock[i];
                if (command.commandRoot.includes(commandPatternToLookFor) ||
                    command.commandParts.some((arg) => commandPatternToLookFor.includes(arg))) {
                    let indexOfExactMatch = this.otherCommandPatternsToMock.indexOf(this.attemptedCommand);
                    if (indexOfExactMatch === -1) {
                        indexOfExactMatch = this.otherCommandPatternsToMock.indexOf(command.commandParts.join(' '));
                    }
                    if (indexOfExactMatch !== -1) {
                        // If we have an exact match, return the value for that command.
                        return this.otherCommandsReturnValues[indexOfExactMatch];
                    }
                    return this.otherCommandsReturnValues[i];
                }
            }
            if (this.shouldActuallyExecuteCommand(command)) {
                return this.trueExecutor.execute(command, options, terminalFailure);
            }
            return this.fakeReturnValue;
        });
    }
    executeMultipleCommands(commands, options, terminalFailure) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = [];
            for (const command of commands) {
                result.push(yield this.execute(command, options, terminalFailure));
            }
            return result;
        });
    }
    tryFindWorkingCommand(commands) {
        return __awaiter(this, void 0, void 0, function* () {
            return commands[0];
        });
    }
    /**
     * @remarks For commands which do not edit the global system state or we don't need to mock their data, we can just execute them
     * with a real command executor to provide better code coverage.
     */
    shouldActuallyExecuteCommand(command) {
        return !command.runUnderSudo && this.fakeReturnValue.status === '' && this.fakeReturnValue.stderr === '' && this.fakeReturnValue.stdout === '';
    }
    resetReturnValues() {
        this.fakeReturnValue = { status: '', stderr: '', stdout: '' };
        this.attemptedCommand = '';
        this.otherCommandPatternsToMock = [];
        this.otherCommandsReturnValues = [];
    }
    setEnvironmentVariable(variable, value, vscodeContext, failureWarningMessage, nonWinFailureMessage) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.trueExecutor.setEnvironmentVariable(variable, value, vscodeContext, failureWarningMessage, nonWinFailureMessage);
        });
    }
}
exports.MockCommandExecutor = MockCommandExecutor;
class MockFileUtilities extends IFileUtilities_1.IFileUtilities {
    constructor() {
        super(...arguments);
        this.trueUtilities = new FileUtilities_1.FileUtilities();
        this.filePathsAndExistValues = {};
        this.filePathsAndReadValues = {};
    }
    writeFileOntoDisk(content, filePath) {
        return this.trueUtilities.writeFileOntoDisk(content, filePath, new MockEventStream());
    }
    wipeDirectory(directoryToWipe, eventSteam, fileExtensionsToDelete, verifyDotnetNotInUse) {
        return this.trueUtilities.wipeDirectory(directoryToWipe, eventSteam, fileExtensionsToDelete);
    }
    isElevated(context, utilContext) {
        return this.trueUtilities.isElevated(context, utilContext);
    }
    getFileHash(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            return '';
        });
    }
    exists(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.filePathsAndExistValues[filePath] || new FileUtilities_1.FileUtilities().exists(filePath);
        });
    }
    read(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.filePathsAndReadValues[filePath] || '';
        });
    }
    realpath(filePath) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.filePathsAndReadValues[filePath] || new FileUtilities_1.FileUtilities().realpath(filePath);
        });
    }
}
exports.MockFileUtilities = MockFileUtilities;
/**
 * @remarks does NOT run the commands (if they have sudo), but records them to verify the correct command should've been run.
 */
class MockDistroProvider extends IDistroDotnetSDKProvider_1.IDistroDotnetSDKProvider {
    constructor(version, context, utilContext, commandRunner) {
        super(version, context, utilContext, commandRunner);
        this.installReturnValue = '';
        this.installedSDKsReturnValue = [];
        this.installedRuntimesReturnValue = [];
        this.globalPathReturnValue = '';
        this.globalVersionReturnValue = '';
        this.distroFeedReturnValue = '';
        this.microsoftFeedReturnValue = '';
        this.packageExistsReturnValue = false;
        this.supportStatusReturnValue = "DISTRO" /* DotnetDistroSupportStatus.Distro */;
        this.recommendedVersionReturnValue = '';
        this.upgradeReturnValue = '';
        this.uninstallReturnValue = '';
        this.versionPackagesReturnValue = [];
        this.context = context;
    }
    installDotnet(fullySpecifiedVersion) {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand('install', [`dotnet`]));
        return Promise.resolve(this.installReturnValue);
    }
    getInstalledDotnetSDKVersions() {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`get`, [`sdk`, `versions`]));
        return Promise.resolve(this.installedSDKsReturnValue);
    }
    getInstalledDotnetRuntimeVersions() {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`get`, [`runtime`, `versions`]));
        return Promise.resolve(this.installedRuntimesReturnValue);
    }
    getInstalledGlobalDotnetPathIfExists() {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`global`, [`path`]));
        return Promise.resolve(this.globalPathReturnValue);
    }
    getInstalledGlobalDotnetVersionIfExists() {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`global`, [`version`]));
        return Promise.resolve(this.globalVersionReturnValue);
    }
    getExpectedDotnetDistroFeedInstallationDirectory() {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`distro`, [`feed`, `dir`]));
        return this.distroFeedReturnValue;
    }
    getExpectedDotnetMicrosoftFeedInstallationDirectory() {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`microsoft`, [`feed`, `dir`]));
        return this.microsoftFeedReturnValue;
    }
    dotnetPackageExistsOnSystem(fullySpecifiedVersion) {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`package`, [`check`]));
        return Promise.resolve(this.packageExistsReturnValue);
    }
    getDotnetVersionSupportStatus(fullySpecifiedVersion) {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`support`, [`status`]));
        return Promise.resolve(this.supportStatusReturnValue);
    }
    getRecommendedDotnetVersion(installType) {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`recommended`, [`version`]));
        return Promise.resolve(this.recommendedVersionReturnValue);
    }
    upgradeDotnet(versionToUpgrade) {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`upgrade`, [`update`, `dotnet`]));
        return Promise.resolve(this.upgradeReturnValue);
    }
    uninstallDotnet(versionToUninstall) {
        this.commandRunner.execute(CommandExecutor_1.CommandExecutor.makeCommand(`uninstall`, [`dotnet`]));
        return Promise.resolve(this.uninstallReturnValue);
    }
    JsonDotnetVersion(fullySpecifiedDotnetVersion) {
        return new GenericDistroSDKProvider_1.GenericDistroSDKProvider(this.distroVersion, this.context, (0, TestUtility_1.getMockUtilityContext)()).JsonDotnetVersion(fullySpecifiedDotnetVersion);
    }
    isPackageFoundInSearch(resultOfSearchCommand, searchCommandExitCode) {
        return true;
    }
}
exports.MockDistroProvider = MockDistroProvider;
class FailingInstallScriptWorker extends InstallScriptAcquisitionWorker_1.InstallScriptAcquisitionWorker {
    constructor(ctx) {
        super(ctx);
        this.webWorker = new MockWebRequestWorker();
    }
    getDotnetInstallScriptPath() {
        throw new Error('Failed to write file');
    }
}
exports.FailingInstallScriptWorker = FailingInstallScriptWorker;
class MockTelemetryReporter {
    dispose() {
        return __awaiter(this, void 0, void 0, function* () {
            // Nothing to dispose
        });
    }
    sendTelemetryEvent(eventName, properties, measures) {
        MockTelemetryReporter.telemetryEvents = MockTelemetryReporter.telemetryEvents.concat({ eventName, properties, measures });
    }
    sendTelemetryErrorEvent(eventName, properties, measures, errorProps) {
        eventName = `[ERROR]:${eventName}`;
        MockTelemetryReporter.telemetryEvents = MockTelemetryReporter.telemetryEvents.concat({ eventName, properties, measures });
    }
}
exports.MockTelemetryReporter = MockTelemetryReporter;
MockTelemetryReporter.telemetryEvents = [];
class MockInstallationValidator extends IInstallationValidator_1.IInstallationValidator {
    validateDotnetInstall(version, dotnetPath) {
        // Always validate
    }
}
exports.MockInstallationValidator = MockInstallationValidator;
class MockLoggingObserver {
    post(event) {
        // Nothing to post
    }
    dispose() {
        // Nothing to dispose
    }
    getFileLocation() {
        return 'Mock file location';
    }
}
exports.MockLoggingObserver = MockLoggingObserver;
class MockExtensionConfiguration {
    constructor(existingPaths, enableTelemetry, existingSharedPath, allowInvalidPaths = false) {
        this.existingPaths = existingPaths;
        this.enableTelemetry = enableTelemetry;
        this.existingSharedPath = existingSharedPath;
        this.allowInvalidPaths = allowInvalidPaths;
    }
    update(section, value) {
        // Not used, stubbed to implement interface
        return new Promise((resolve) => resolve());
    }
    get(name) {
        if (name === 'existingDotnetPath') {
            return this.existingPaths;
        }
        else if (name === 'sharedExistingDotnetPath') {
            return this.existingSharedPath;
        }
        else if (name === 'enableTelemetry') {
            return this.enableTelemetry;
        }
        else if (name === 'allowInvalidPaths') {
            return this.allowInvalidPaths;
        }
        else if (name === 'showResetDataCommand') {
            return true;
        }
        else {
            return undefined;
        }
    }
}
exports.MockExtensionConfiguration = MockExtensionConfiguration;
class MockInstallTracker extends InstallTrackerSingleton_1.InstallTrackerSingleton {
    constructor(eventStream, extensionState) {
        super(eventStream, extensionState);
        // Cause an instance to exist so that we can override the members.
        const _ = InstallTrackerSingleton_1.InstallTrackerSingleton.getInstance(eventStream, extensionState);
        this.overrideMembers(eventStream, extensionState);
    }
    getExtensionState() {
        return this.extensionState;
    }
    setExtensionState(extensionState) {
        this.extensionState = extensionState;
    }
}
exports.MockInstallTracker = MockInstallTracker;
//# sourceMappingURL=MockObjects.js.map